import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

import { EditInformationTemplateContext } from "../../../../hooks/contexts";
import FreeTextInfoTemplate from "./freeTextInfoTemplate";

const generateInitialCategoryField = (ift, setInformationTemplates) => {
    setInformationTemplates((previousInfoTemplates) => {
        let infoTemplates = _.cloneDeep(previousInfoTemplates);

        // Updated template replaced with previous one in the list
        const updatedTemplates = infoTemplates.map((t) => {
            if (t.TEMPLATE_CODE === ift.TEMPLATE_CODE) return ift;

            return t;
        });

        return updatedTemplates;
    });
    return null;
};

const InformationTemplateGenerator = ({ ift, setInformationTemplates }) => {
    const editPageInputs = useContext(EditInformationTemplateContext); // can be null. Do not send wrap context provider if to be read only
    useEffect(() => {
        updateCategoryField();
    }, []);

    const updateCategoryField = () => {
        editPageInputs &&
            editPageInputs.updateInfomationTemplateField(
                generateInitialCategoryField(ift, setInformationTemplates)
            );
    };

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h5" color="text.subheader">
                    {ift?.TEMPLATE_NAME}
                </Typography>
                <Typography variant="body1">
                    {ift?.ATTACH_CATEGORY_NAME}
                </Typography>
            </Grid>
            {ift?.TEMPLATES.map((iftField, index) => (
                <Grid item xs={6} key={index}>
                    <FreeTextInfoTemplate
                        key={index}
                        iftField={iftField}
                        iftValue={{ id: null }}
                        setIftValue={null}
                        updateCategoryField={updateCategoryField}
                    />
                </Grid>
            ))}
        </>
    );
};

FreeTextInfoTemplate.propTypes = {
    ift: PropTypes.object,
};

export default InformationTemplateGenerator;
